import React from 'react';
import useCollapse from '../hooks/useCollapse';
import parseClassnames from '../helpers/parseClassnames';
import { CollapseProps } from './types';

const Collapse: React.FC<CollapseProps> = ({
  children,
  open,
  defaultOpen,
  collapsedHeight,
  onOpenCallback,
  onCloseCallback,
  className = '',
  ...rest
}) => {
  const { getCollapseProps, toggleOpen } = useCollapse({
    isOpen: open,
    defaultOpen: false,
    collapsedHeight: collapsedHeight || 0,
    onOpenCallback,
    onCloseCallback,
  });

  React.useEffect(() => {
    toggleOpen();
  }, [open]);

  return (
    <div {...getCollapseProps()} {...rest}>
      <div className={parseClassnames(className, 'flex items-center relative')}>
        {children}
      </div>
    </div>
  );
};

export default Collapse;
